import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';

export class AwardWinner extends React.Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false,
            isShowError: false,
        }
    }




    onSubmit(e) {
        e.preventDefault();
        axios.get(baseURL).then(res => {
            let formData = {
                "amount": this.state.amount.toString()
            }

            var sha512 = require('js-sha512');
            let signature = sha512(this.state.amount.toString() + 'P@s5w0rd_5@lt')

            this.setState({ isLoading: true });
            axios.post('https://luckybox.ng:3884/award_customer', formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    "signature": signature

                }
            }).then((response) => {
                console.log("bayo", response.data)
                if (response.data.code === "0000") {

                    alert(JSON.stringify(response.data.message))
                    this.setState({
                        statusMessage: response.data.message,
                        customer: response.data.customer,
                        isShowError: true, isLoading: false, showError: false,
                    });
                    // alert(response.data.msisdn)
                    window.setTimeout(function () {
                        this.setState({
                            statusMessage: response.data.message,
                            isShowError: true, isLoading: false, showError: false,
                        });
                    }, 10000);

                } else {

                    this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
                }
            }).catch(error => {
                console.log('bayoo', error.response)
                this.setState({
                    showError: true,
                    isShowError: false,
                    statusMessage: error.response.data.message,
                    submitted: true,
                    isLoading: false
                });
            });
        });

    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent } = this.state;

        return (
            <div className="pcoded-main-container">

                {showComponent && (
                    <div>

                        {this.state.showComponent ?
                            <peopleView /> : null
                        }

                    </div>
                )}

                {!hideComponent && (
                    <>

                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody><br />

                                    <div className="card__title">
                                        <h5 className="bold-text">Award Winner </h5>
                                    </div>

                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}

                                    </div> : null}<br></br>

                                    {this.state.isShowError ? (
                                        <div
                                            color="success"
                                            style={{ fontSize: "13px", color: "black", fontStyle: "bold" }}>
                                            {this.state.customer != null ?
                                                <>
                                                    <h4>Customer <b>{this.state.customer.name}</b></h4>
                                                    <h4>Phone <b >{this.state.customer.msisdn}</b></h4>
                                                    <h4>Balance <b>{this.state.customer.balance}</b></h4>
                                                </>
                                                : null}

                                        </div>

                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>

                                        <div className="form-group">
                                            <label className="form-label">ENTER AMOUNT</label>
                                            <input id="input" type="text" className="form-control input-md"
                                                name="amount" required placeholder="Enter AMount"
                                                value={this.state.amount} onChange={this.handleChange} />
                                        </div>
                                        <br />
                                        <div className="col-md-12">
                                            <Button type="submit" outline color="primary" className="btn-paypal btn-lg pull-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
